import { useContext } from "react";
import { FaHeart } from "react-icons/fa";
import { AppContext } from "~/context/AppContext";
import { AppLevelModalType } from "~/types/general";

export const HeartsChip = ({ hearts }: { hearts: number }) => {
  const { gameData, openAppLevelModal } = useContext(AppContext);
  return (
    <button
      onClick={() => {
        if (!gameData?.isPro) {
          openAppLevelModal(AppLevelModalType.Paywall);
        }
      }}
      className="text-warning text-2xl flex flex-row justify-center items-center gap-1 active:opacity-50"
      style={{
        color: hearts > 0 ? "#FF147E" : "#777777",
      }}
    >
      {gameData?.isPro ? (
        <p className="font-bangers text-secondary">PRO</p>
      ) : (
        <>
          <FaHeart className="" />
          <p className="font-chewy leading-none">{hearts}</p>
        </>
      )}
    </button>
  );
};
